var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTaxonomiActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50187 14.1985C3.50219 14.395 3.56031 14.5875 3.66937 14.7513L4.20344 15.5541C4.29467 15.6913 4.41841 15.8039 4.56366 15.8817C4.7089 15.9596 4.87114 16.0003 5.03594 16.0003H6.96438C7.12917 16.0003 7.29141 15.9596 7.43665 15.8817C7.5819 15.8039 7.70564 15.6913 7.79688 15.5541L8.33094 14.7513C8.43995 14.5875 8.49822 14.3952 8.49844 14.1985L8.49969 13H3.50031L3.50187 14.1985ZM0.5 5.50003C0.5 6.88659 1.01406 8.15159 1.86125 9.11815C2.3775 9.70721 3.185 10.9378 3.49281 11.976C3.49406 11.9841 3.495 11.9922 3.49625 12.0003H8.50375C8.505 11.9922 8.50594 11.9844 8.50719 11.976C8.815 10.9378 9.6225 9.70721 10.1388 9.11815C10.9859 8.15159 11.5 6.88659 11.5 5.50003C11.5 2.45659 9.02844 -0.00934836 5.98281 2.66431e-05C2.795 0.00971414 0.5 2.59284 0.5 5.50003ZM6 3.00003C4.62156 3.00003 3.5 4.12159 3.5 5.50003C3.5 5.77628 3.27625 6.00003 3 6.00003C2.72375 6.00003 2.5 5.77628 2.5 5.50003C2.5 3.57003 4.07 2.00003 6 2.00003C6.27625 2.00003 6.5 2.22378 6.5 2.50003C6.5 2.77628 6.27625 3.00003 6 3.00003Z",
    fill: "#DDE2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTaxonomiActive);
export default __webpack_public_path__ + "static/media/menu-taxonomi-active.9ac78e7194389553e5e3ab88759895f5.svg";
export { ForwardRef as ReactComponent };